import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
// import { faker } from '@faker-js/faker';
import PropTypes from 'prop-types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function BarChart({ xGraphData, yGraphData }) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: false,
        text: 'משקל גוף'
      },
      filler: {
        propagate: true
      }
    }
  };
  // const labels = ['08.21', '09.21', '10.21', '11.21', '12.21', '01.21', '02.21', '03.21', '04.21'];
  const labels = yGraphData;
  const data = {
    labels,
    datasets: [
      {
        label: '',
        // data: labels.map(() => faker.datatype.number({ min: 100, max: 150 })),
        data: xGraphData,
        borderColor: '#002a6a',
        backgroundColor: '#002a6a',
        fill: true,
        tension: 0.3,
        borderCapStyle: 'around',
        stepped: false
      }
    ]
  };
  return <Line options={options} data={data} />;
}

BarChart.propTypes = {
  xGraphData: PropTypes.array,
  yGraphData: PropTypes.array
};
